import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { Transition } from 'lumen/services/transition';

export default class HotelSettingsCentralMappingRoute extends Route {
  @service declare centralMapping: Services['central-mapping'];
  @service declare navigation: Services['navigation'];
  @service declare router: Services['router'];

  beforeModel(transition: Transition): void {
    if (!this.centralMapping.hasCentralMappingHotelAccess) {
      this.router.transitionTo('hotel.settings');
      return;
    }

    if (transition.to.name === 'hotel.settings.central-mapping.index') {
      this.router.transitionTo('hotel.settings.central-mapping.menu');
      return;
    }

    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/require-await
  async model() {
    const model = {
      breakdowns: this.centralMapping.getBreakdownsTask,
    };

    void model.breakdowns.perform();

    return model;
  }
}
